import { useDynamicViewSchema } from "../DynamicViewSchemaProvider/DynamicViewSchemaProvider";
import { ViewDefinition } from "../DynamicViewSchemaProvider/DynamicViewSchemaProvider.types";

export const useViewDefinition = (
  viewCode: string,
  caseTypeCode?: string
): ViewDefinition | undefined => {
  const uiSchema = useDynamicViewSchema();
  const viewDefinitions = uiSchema.viewDefinitions;

  return viewDefinitions.find(
    (definition) => definition.code === viewCode && definition.caseType === caseTypeCode
  );
};
